module.exports = __webpack_public_path__ + "media/images/Map-ec5e0b21aa8e0f0ee19e77e177295f90.svg";